//---------  Global imports
import React from 'react';
import Link from 'gatsby-link';

//---------  Plugins
import Slider from 'react-slick';
import { forEach, filter, throttle } from 'lodash';

//---------	Commons
import { matchHeight } from '../Shared/Commons'

//---------  Styles
import './styles.sass'
import '../../css/partials/slider.sass'

//---------  Translations
import { T } from '../../../translations'

//---------  Products List
import productsList from '../../pages/shop/productsList.json'



class RelatedProducts extends React.Component {

  //---------  Constructor
  constructor(props){
    super();

    this.title = props.title ? props.title : T.relatedProducts.title;
    this.alternate = props.alternate;
    this.renderedProducts = [];
    this.products = productsList;
    this.throttled = throttle(()=>matchHeight('.slick-slide a'), 100);
    this.slick = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
           {
            breakpoint: 650,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
           }
        ],
        beforeChange: () => {
            matchHeight('.slick-slide a')
        }
    };

    this.sortedPages = this.sortedPages.bind(this);
  }

  //---------  React functions
    componentWillMount() {
        this.sortedPages()
    }
    componentDidMount() {
        setTimeout(() => matchHeight('.slick-slide a'),300);
        window.addEventListener('resize', this.throttled)
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.throttled)
    }

    //---------  Custom functions
  sortedPages(){
    const sortedPages = [];

    forEach(this.products, (product, key) => {

        sortedPages.push(
            <div key={key} className="CalipsyRelatedProducts-product">
                <Link to={ product.path }>
                    <div className="CalipsyRelatedProducts-image">
                        <img src={ product.thumbnail } alt=""/>
                        <button className="CalipsyButton"><span>view details</span></button>
                    </div>
                    <div className="CalipsyRelatedProducts-details">
                        <h3>{ product.name } <span>from <strong>£{ product.price }<sup>00</sup></strong></span></h3>
                    </div>
                </Link>
            </div>
        )
    });

    this.renderedProducts = this.doShuffle(sortedPages);
  }

  doShuffle(o) {
    for(var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
    return o;
  }


  //---------  Render
  render () {

    let className = "CalipsyRelatedProducts";
    if(this.alternate) className += ' alternate';

    return (
        <div className={ className  }>
            <div className="CalipsyContainer">
                <h2>{ this.title }</h2>

                <div className="CalipsySlider">
                    { this.renderedProducts.length ? <Slider {...this.slick}>{ this.renderedProducts.slice(0,6) }</Slider> : null }
                </div>

                <h3 className="CalipsyRelatedProducts-browseEmAll">
                   <Link to="/shop/">
                       { T.relatedProducts.subtitle[0] }
                       <br />
                       <span>{ T.relatedProducts.subtitle[1] }</span>
                   </Link>
                </h3>
            </div>
        </div>
    )
  }
}

export default RelatedProducts;


// WEBPACK FOOTER //
// ./src/components/RelatedProducts/index.js